<template>
  <div class="hab-detail-gallery">
    <div
        v-if="isLoading"
        class="text-center"
    >
      <loading />
    </div>
    <div v-else-if="!isLoading && dataSource?.length !== 0" class="gallery">
      <VueSlickCarousel
        class="hab-detail-gallery__for"
        ref="c1"
        :asNavFor="c2"
        :focusOnSelect="true"
        :arrows="true"
        :dots="false"
      >
        <div
          class="gallery-item"
          v-for="(item, index) in dataSource"
          :key="index"
        >
          <div
            class="gallery-image"
            :style="{ backgroundImage: `url(${item.files?.['1000x600']})` }"
          >
            <img :src="item.files?.['1000x600']" :alt="item?.alt?.[locale]" />
          </div>
        </div>
      </VueSlickCarousel>
      <VueSlickCarousel
        class="hab-detail-gallery__nav"
        ref="c2"
        :asNavFor="c1"
        :slidesToShow="4"
        :focusOnSelect="true"
        :arrows="false"
        :dots="false"
      >
        <div
          class="gallery-item"
          v-for="(item, index) in dataSource"
          :key="index"
        >
          <div
            class="gallery-image"
            :style="{ backgroundImage: `url(${item.files?.['1000x600']})` }"
          >
            <img :src="item.files?.['1000x600']" :alt="item?.alt?.[locale]" />
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>
<script>
import loading from "../../../loading/index";
import VueSlickCarousel from "vue-slick-carousel";

export default {
  components: {
    loading,
    VueSlickCarousel,
  },
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      locale: locale,
      c1: undefined,
      c2: undefined,
    };
  },
  mounted() {
    this.c1 = this.$refs.c1;
    this.c2 = this.$refs.c2;
  },
};
</script>
